import styled from '@emotion/styled'
import { PharmacIcon } from '@pharmac/ui'

const ApprovalLinkRoot = styled.div`
  a {
    font-size: var(--typo-h6-size);
    font-family: var(--font-family-primary);
    font-weight: 700;
    color: var(--color-primary);

    :visited {
      color: var(--color-primary);
    }

    :hover {
      color: var(--color-purple-light);
      cursor: pointer;
    }

    svg {
      display: inline;
      margin-left: var(--spacing-small);
    }
  }
`

type ApprovalLinkProps = {
  text: string
  url: string
}

export const ApprovalLink = ({ text, url }: ApprovalLinkProps) => {
  return (
    <ApprovalLinkRoot>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {text}
        <PharmacIcon
          stroke="purple"
          size="16px"
          icon="externalLink"
        />
      </a>
    </ApprovalLinkRoot>
  )
}
